/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable prettier/prettier */
import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useIdleTimer } from "react-idle-timer";
import IdlePopUp from "../IdlePopUp/IdlePopUp";
import fetchConfig from "../../Constants/fetch";

export default function IdleTimerContainer({
  endGameFunction,
  gameId,
  userId,
  playerPosition,
  isGamePaused,
  showReport,
  toggleIsGamePaused,
  setKeepShowing,
  keepShowing,
  isCardCountDownActive,
}) {
  let interval;
  const [show, setIdlePopup] = useState(false);
  const [isTabActive, setIsTabActive] = useState(true);

  const handleOnIdle = (event) => {
    console.log("idle no enters? ", isCardCountDownActive);
    if (!isGamePaused && !showReport && !isCardCountDownActive) {
      // checks idle time,if passed 3 min pop up appears.
      console.log("i am in, it was: - ", isCardCountDownActive);
      interval = setInterval(async () => {
        const elapsed = getElapsedTime() / 1000 / 60;

        if (elapsed >= 3) {
          setIsTabActive(false);
          toggleIsGamePaused(true);
          clearInterval(interval);
        }
        return null;
      }, 60 * 1000);
      // setElapsedTime(interval);
    } else if (interval) {
      clearInterval(interval);
    }
  };
  // resets timeout timer on event;
  const handleOnActive = (event) => {
    reset();
    clearInterval(interval);
  };

  const handleOnAction = (event) => {
    reset();
    clearInterval(interval);
  };

  const { getRemainingTime, getLastActiveTime, getElapsedTime, reset, pause } =
    useIdleTimer({
      //   timeout: 60 * 1000
      timeout: 6 * 1000,
      onIdle: handleOnIdle,
      onActive: handleOnActive,
      onAction: handleOnAction,
      debounce: 500,
    });

  return (
    <IdlePopUp
      isTabActive={isTabActive}
      setIdlePopup={setIdlePopup}
      setIsTabActive={setIsTabActive}
      toggleIsGamePaused={toggleIsGamePaused}
      setKeepShowing={setKeepShowing}
      keepShowing={keepShowing}
    />
  );
}
